import { useEffect, useState } from "react"
import { Link } from "react-router-dom";


export default function NewPlogs() {
    const Api_Url = process.env.REACT_APP_API_BASE_URL;

    const [plog, setPlog] = useState([]);

    useEffect(() => {
        fetch(`${Api_Url}/plog/show/all`)
            .then((res) => res.json())
            .then((data) => { setPlog(data) })
    }, [])

    return (
        <div className='w-[90%] my-10 mx-auto lg:mx-0 lg:my-0 lg:w-[40%] '>
            <h1 className='text-black text-3xl font-bold dark:text-white'>
                أحدث المقالات
            </h1>
            {
                plog?.map((item) => (
                    <Link to={`/blog/${item.id}/${item.title}`} key={item.id}>
                        <div className='w-full h-[70px] rounded-xl bg-[#880807] mt-4 content-visibility-auto' >
                            <h3 className="text-white text-lg font-medium p-2">
                                {item.title}
                            </h3>
                        </div>
                    </Link>
                ))
            }

        </div>
    )
}
